import React from "react";

const DropdownDivider = ({}) => {
    return <div className="dropdown-divider" />;
};

export { DropdownDivider };
